import { QueryClient } from '@tanstack/react-query';

/**
 * App-wide React Query client. A module singleton (not created inside a
 * component) so the sign-out path in `authStore.logout()` can empty it —
 * otherwise the next user to sign in in the same tab is served the previous
 * user's cached channels, messages and profile until each query refetches.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      // Longer staleTime for most queries — realtime updates come over the
      // socket so the REST cache can happily serve stale data in the
      // background without triggering extra refetches.
      staleTime: 60_000,
      gcTime: 5 * 60_000,
    },
  },
});
